import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ExitToAppIcon(props: IconProps) {
    return <Icon {...props} iconKey={"exit_to_app"}/>
}
